export const getTreeSelectData = (data, t) => {
  return data ? [{ name: t('All'), id: 'all' }, ...data] : [];
};
